import { Component, OnInit } from '@angular/core';
import { Common } from 'app/shared/utility/common';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../services/dataService';
import { OcmeComponent } from 'app/dashboard/ocme/ocme.component';
import { AuthenticationService } from '../services/authenticationService';
import { CaseReportComponent } from 'app/dashboard/caseReport/caseReport.component';
import { ResourceCenterComponent } from 'app/dashboard/resource-center/resource-center.component';
import { BaseComponent } from '../baseClasses/BaseComponent';
import { AppConfig } from 'app/app.config';
import { EventAggregator, EventList } from '../utility/EventAggregator';
import { EventTypes, StorageConstants } from '../utility/constants';
import { CommentService } from '../services/commentService';
import { BannerNotification, NotificationService } from '../services/notificationService';

@Component({
  selector: 'app-secure',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent extends BaseComponent implements OnInit {
  isAdmin = false;
  messageCaseList: Array<any> = [];
  messageCaseListLoading: boolean = false;
  bannerList: Array<BannerNotification> = [];
  bannerListLoading : boolean = null;
  refreshJob: any = null;

  constructor(
    appConfig: AppConfig,
    private modal: MatDialog,
    private dataService: DataService,
    private authService: AuthenticationService,
    private commentService: CommentService,
    private notificationService: NotificationService
  ) {
    super(appConfig);
  }

  ngOnInit() {
    this.dataService.getAccess().subscribe((access) => {
      this.isAdmin = access.IsAdmin;
    });
    this.authService.refreshToken();
    this.getUnreadCommentList();
    this.getBannerList();

    this.subscribeEvent(EventList.messageCaseListRefresh, (event) => {
      this.getUnreadCommentList(true);
    });

    this.subscribeEvent(EventList.bannerListRefresh, (event) => {
      this.getBannerList(true);
    })

    this.refreshJob = setInterval(() => {
      this.getUnreadCommentList(true);
      this.getBannerList(true);
    }, 20000);
  }

  ngOnDestroy() {
    clearInterval(this.refreshJob);
  }

  getBannerList(is_refresh = false) {
    this.bannerListLoading = !is_refresh  ;
    this.notificationService.GetLatestNotification().then(notifications => {
      if(notifications.length > 1) {
        this.bannerList = notifications.slice(1);
      } else {
        this.bannerList = [];
      }
      this.bannerListLoading = false;
    })
  }

  getUnreadCommentList(is_refresh = false) {
    this.messageCaseListLoading = !is_refresh;
    this.commentService.GetCommentThreadInfosFiltered().then(res => {
      this.messageCaseList = [];
      for(var i = 0; i < res.length; i++) {
        if(res[i].HasUnreadComments == true) {
          this.messageCaseList.push({
            id : res[i].id,
            caseId : res[i].CaseId,
            ocme : res[i].Ocme,
            lastUpdated : res[i].LastUpdated
          });
        }
      }
      this.messageCaseList.sort((a, b) => Date.parse(b.lastUpdated).valueOf() - Date.parse(a.lastUpdated).valueOf());
      this.messageCaseListLoading = false;
    });
  }

  openResources() {
    this.modal.open(ResourceCenterComponent, Common.ModalConfig);
  }

  openOCME() {
    this.modal.open(OcmeComponent, Object.assign({ data: false }, Common.ModalConfig));
  }

  openNonFatal() {
    this.modal.open(OcmeComponent, Object.assign({ data: true }, Common.ModalConfig));
  }

  openICD() {
    this.modal.open(
      CaseReportComponent,
      Object.assign({ data: { type: "OCME", title: "Incident Census Report Download" } }, Common.ModalConfig)
    );
  }

  openCRD() {
    this.modal.open(
      CaseReportComponent,
      Object.assign({ data: { type: "FULL", title: "Case Report Download" } }, Common.ModalConfig)
    );
  }

  openArchiveCases() {
    this.modal.open(
      CaseReportComponent,
      Object.assign({ data: { type: "ARCHIVE", title: "Archive Cases" } }, Common.ModalConfig)
    );
  }

  logout() {
    this.authService.logout();
  }

  goToDashboard() {
    sessionStorage.setItem(StorageConstants.DashboardInit, "false");
    EventAggregator.publish(EventList.dashboardClick, true);
  }

  caseMessageClick(commentThreadInfo) {
    EventAggregator.publish(EventList.popupTriggered, {
      type: EventTypes.CaseCommentThread,
      value: {
        id: commentThreadInfo.id,
        caseId: commentThreadInfo.caseId,
        ocme: commentThreadInfo.ocme }
    });
  }

  dismissBanner(banner) {
    this.notificationService.DismissBannerNotification(banner.id).then(res => {
      this.getBannerList();
    });
  }
}